
import { removeScript, createScript } from '@/utils/script'
import { onBeforeUnmount, onMounted } from 'vue'

export default {
  props: {
    text: {
      type: String,
      default: location.href
    }
  },
  setup() {
    const id = 'twitter-wjs'
    const url = 'https://platform.twitter.com/widgets.js'
    onMounted(() => {
      const twitterInit = () => {
        createScript(id, url)
        const t = (window as any).twttr || {}
        t._e = []
        t.ready = function(f: any) {
          t._e.push(f)
        }
        return t
      }
      ;(window as any).twttr = twitterInit()
    })
    onBeforeUnmount(() => {
      removeScript(id)
    })
  }
}
